<div [ngClass]="{ 'opportunity-container': opportunity.isCompleted }">

  <!-- Modern Card Layout (Figma Design) -->
  <div class="Opportunity modern-layout" *ngIf="opportunityTheme === opportunityThemes.MODERN"
    [routerLink]="['/opportunities/opportunity-details/' + opportunity.opportunityid]">

    <div class="modern-header">
      <h3 class="fund-title" [style.font-size]="fundTitleFontSize" style="white-space: pre-line;">{{ opportunity.fundNameWithMultiLine || opportunity.fundName }}</h3>
      <p class="fund-subtitle">{{ "Opportunities.BY_COMPANY" | translate }} {{ opportunity.companyName }}</p>
    </div>

    <div class="meta-grid">
      <div class="meta-cell" *ngIf="opportunity.fundType === fundTypes.OpenFund">
        <span class="meta-label">{{ "Opportunities.RISK_LEVEL" | translate }}</span>
        <span class="meta-value">{{ opportunity.riskLevelName }}</span>
      </div>
      <div class="meta-cell" *ngIf="opportunity.fundType === fundTypes.OpenFund">
        <span class="meta-label">{{ "Opportunities.CHANGE_SINCE_ESTABLISHMENT" | translate }}</span>
        <span class="meta-value">{{ opportunity.changeSinceEstablishment }}%</span>
      </div>
      <div class="meta-cell status-container">
        <span class="meta-label">{{ "Shared.Status" | translate }}</span>
        <div class="d-flex gap-2 justify-content-end">
          <span class="badge-pill" [ngClass]="{
      'badge-close': opportunity.fundType === fundTypes.CloseFund,
      'badge-open': opportunity.fundType === fundTypes.OpenFund
    }">
            {{ shortFundType }}
          </span>
          <span class="badge-pill badge-status" *ngIf="fundStatusLabel">{{ fundStatusLabel }}</span>
        </div>
      </div>
    </div>

    <div class="modern-panels">
      <div class="roi-box">
        <div class="panel-label">{{ "Opportunities.ROI" | translate }}</div>
        <div class="panel-value">{{ formattedRoi }}</div>
      </div>
      <div class="price-box">
        <div class="panel-label">{{ "Opportunities.UNIT_PRICE" | translate }}</div>
        <div class="panel-value">
          {{ opportunity.unitPrice | unitPrice }}
          <img src="assets/images/SARIcon.svg" style="width:14px">
        </div>
      </div>
    </div>
  </div>
  <!-- Classic Card Layout -->
  <div class="classic-layout" *ngIf="opportunityTheme === opportunityThemes.CLASSIC">
    <div class="Opportunity">
      <div class="d-flex flex-column g-2">
        <div class="Opportunity-img">
          <span class="unit_price">
            <p class="mb-0 font-weight-400">{{ (opportunity.fundType === fundTypes.OpenFund ?
              'Opportunities.CURRENT_UNIT_PRICE_NAV' : 'Opportunities.UNIT_PRICE') | translate }}</p>
            <p class="mb-0 font-weight-700 font-size-5">{{ opportunity.unitPrice | unitPrice }}
              <span><img src="assets/images/SARIcon.svg" class="currency-img" alt=""></span>
            </p>
          </span>
          <img [src]="opportunity.coverPhotoURL || opportunity.companylogoUrl || defaultOpportunityImageUrl"
            onerror="this.src=''+defaultOpportunityImageUrl" alt="" class="w-100" />
        </div>

        <div class="opportunity-data">
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <img [src]="opportunity.companylogoUrl" alt="" class="img-fluid Opportunity-comp-img flex-shrink-0" />
              <div class="comp-data">
                <h5 [style.font-size]="classicFundTitleFontSize" style="white-space: pre-line;">{{ opportunity.fundNameWithMultiLine || opportunity.fundName }}</h5>
                <p class="opportunity-comp">
                  {{ "Opportunities.BY_COMPANY" | translate }} {{ opportunity.companyName }}.
                </p>
              </div>
            </div>
            <a [routerLink]="['/opportunities/opportunity-details/' + opportunity.opportunityid]"
              class="details-icon d-none" *ngIf="!opportunity.isCompleted">
              <i class="font-size-4 ri-external-link-line fund-card-header-icon"></i>
            </a>
          </div>

          <p class="mt-4 lite-color font-weight-500 font-size-3">
            {{ "Opportunities.Fund Type" | translate }}
            <span class="font-weight-700 font-size-3 dark-color">
              {{ "Opportunities." + opportunity.fundType | translate }}
            </span>
          </p>

          <!-- Close Fund Fields -->
          <div class="row d-flex align-items-center py-3" *ngIf="opportunity.fundType==fundTypes.CloseFund">
            <div class="px-1 col-4">
              <div class="info_section with-border-bottom">
                <p>{{ "Opportunities.UNIT_PRICE" | translate }}</p>
                <h6>{{ opportunity.unitPrice | unitPrice }}
                  <span><img src="assets/images/SARIcon.svg" class="currency-img" alt=""></span>
                </h6>
              </div>
            </div>
            <div class="px-1 col-4"
              *ngIf="opportunity.expectedTotalProfit != null && opportunity.expectedTotalProfit != 0">
              <div class="info_section with-border-bottom">
                <p>{{ "Opportunities.EXPECTEDROI" | translate }}</p>
                <h6>{{ opportunity.expectedTotalProfit }}</h6>
              </div>
            </div>
            <div class="px-1 col-4" *ngIf="opportunity.internalRateOfReturn != null">
              <div class="info_section">
                <p>{{ "Opportunities.IRR" | translate }}</p>
                <h6>{{ opportunity.internalRateOfReturn }}%</h6>
              </div>
            </div>
            <div class="px-1 col-4" *ngIf="opportunity.percentageOfChange != null">
              <div class="info_section">
                <p>{{ "Opportunities.PERCENTAGE_CHANGE" | translate }}</p>
                <h6>{{ opportunity.percentageOfChange }}%</h6>
              </div>
            </div>
          </div>

          <!-- Open Fund Fields -->
          <div class="row d-flex align-items-center py-3" *ngIf="opportunity.fundType==fundTypes.OpenFund">
            <div class="px-1 col-4">
              <div class="info_section with-border-bottom">
                <p>{{ "Opportunities.PRICE_SINCE_ESTABLISHMENT" | translate }}</p>
                <h6>{{ opportunity.establishmentPrice | number }}
                  <span><img src="assets/images/SARIcon.svg" class="currency-img" alt=""></span>
                </h6>
              </div>
            </div>
            <div class="px-1 col-4"
              *ngIf="opportunity.expectedTotalProfit != null && opportunity.expectedTotalProfit != 0">
              <div class="info_section with-border-bottom">
                <p>{{ "Opportunities.ROI" | translate }}</p>
                <h6>{{ opportunity.expectedTotalProfit }}</h6>
              </div>
            </div>
            <div class="px-1 col-4" *ngIf="opportunity.changeSinceEstablishment != null">
              <div class="info_section">
                <p>{{ "Opportunities.CHANGE_SINCE_ESTABLISHMENT" | translate }}</p>
                <h6>{{ opportunity.changeSinceEstablishment }}%</h6>
              </div>
            </div>
            <div class="px-1 col-4" *ngIf="opportunity.internalRateOfReturn != null">
              <div class="info_section">
                <p>{{ "Opportunities.IRR" | translate }}</p>
                <h6>{{ opportunity.internalRateOfReturn }}%</h6>
              </div>
            </div>
            <div class="px-1 col-6" *ngIf="opportunity.lastPublishedNav != null">
              <div class="info_section with-border-bottom">
                <p>{{ "Opportunities.LAST_PUBLISHED_NAV" | translate }}</p>
                <h6>{{ opportunity.lastPublishedNav | number }}
                  <span><img src="assets/images/SARIcon.svg" class="currency-img" alt=""></span>
                </h6>
              </div>
            </div>
            <div class="px-1 col-6" *ngIf="opportunity.changeSinceLastValuation != null">
              <div class="info_section">
                <p>{{ "Opportunities.CHANGE_SINCE_LAST_VALUATION" | translate }}</p>
                <h6>{{ opportunity.changeSinceLastValuation }}%</h6>
              </div>
            </div>
          </div>

          <!-- Progress Bar (Classic theme only) -->
          <div class="row progress_section" *ngIf="opportunity.totalUnits>0">
            <div class="col-6 text-start">
              <p>{{ "Opportunities.FUND_TARGET" | translate }}</p>
              <h6>{{ opportunity.projectTotalValue | number }}
                <span><img src="assets/images/SARIcon.svg" class="currency-img" alt=""></span>
              </h6>
            </div>
            <div class="col-6 text-end">
              <p>{{ "Opportunities.COMPLETED" | translate }}</p>
              <h6>{{ opportunity.soldPercentage }}%</h6>
            </div>
            <div class="col-12">
              <mat-progress-bar class="example-margin" [color]="color" [mode]="mode"
                [value]="opportunity.soldPercentage">
              </mat-progress-bar>
            </div>
          </div>

          <!-- Details Button -->
          <div class="details-btn row d-flex align-items-center justify-content-center pt-4 m-2"
            *ngIf="!opportunity.isCompleted && (opportunityStatus == fundStatus.Current || opportunityStatus == fundStatus.Upcoming)">
            <button class="btn-block"
              [routerLink]="['/opportunities/opportunity-details/' + opportunity.opportunityid]">
              {{ "Opportunities.VIEW_DETAILS" | translate }}
              <i [ngClass]="{'ri-arrow-right-line': languageService.currentLanguage=='en',
                             'ri-arrow-left-line': languageService.currentLanguage=='ar'}"></i>
            </button>
          </div>
        </div>

        <img [src]="'../../../../assets/images/'+tenantId+'/Stamp.svg'" class="stamp" alt="Stamp"
          *ngIf="opportunity.isCompleted" />
      </div>
    </div>
  </div>
</div>